import { render, staticRenderFns } from "./AiPic.vue?vue&type=template&id=351bc1df&scoped=true"
import script from "./AiPic.vue?vue&type=script&lang=js"
export * from "./AiPic.vue?vue&type=script&lang=js"
import style0 from "./AiPic.vue?vue&type=style&index=0&id=351bc1df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@2.8.8_vue-template-compiler@2.7.16_webpack@5.101.3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351bc1df",
  null
  
)

export default component.exports